module.exports = __webpack_public_path__ + "static/img/22_pro.cbbc3f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/22_pro.jpg
// module id = CuyN
// module chunks = 0